<template>
  <a-spin :spinning="loading">
    <a-form-model ref="form" :model="form" @keyup.enter.native="handleSubmit" :rules="rules">
      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        v-if="!isModal && !executeDisabled && changePlanId"
        label="确定"
        class="no-label"
        style="margin-bottom: 11px; margin-top: -12px; font-size: 15px"
      >
        <span style="color: var(--color-grey)">内容变更后请点击这里 </span>
        <a-icon style="color: var(--color-grey); margin-right: 10px" type="arrow-right" />
        <a @click="handleSubmit">保存</a>
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        :label="$t('disp.departName')"
        prop="departName"
      >
        <a-input
          :placeholder="$t('disp.ph.input', [$t('disp.departName')])"
          v-model="form.departName"
          :maxLength="100"
        />
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        :label="$t('disp.parentDepart')"
        prop="parentId"
      >
        <a-tree-select
          v-model="form.parentId"
          :treeData="departTree"
          treeDefaultExpandAll
          :placeholder="$t('disp.ph.select', [$t('disp.parentDepart')])"
          :disabled="true"
        ></a-tree-select>
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        :label="$t('disp.orgCode')"
        prop="orgCode"
        v-if="!isModal"
      >
        <a-input disabled v-model="form.orgCode" />
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        label="NCC编号"
        prop="nccCode"
        v-if="!isModal"
      >
        <a-input v-model="form.nccCode" placeholder="请填写NCC编号" />
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        :label="$t('disp.orgCategory')"
        prop="orgCategory"
      >
        <j-dict-select-tag v-model="form.orgCategory" dictCode="org_category" type="radio" :triggerChange="true" />
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        label="纳入资金统计"
        prop="isFundStat"
      >
        <a-switch size="small" v-model="form.isFundStat" style="position: relative; top: -1px" />
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        :label="$t('disp.sort')"
        prop="sortOrder"
      >
        <a-input-number style="width: 145px" v-model="form.sortOrder" :min="0" :max="999999999999" :step="100" />
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        label="部门分管领导"
        prop="departBranchLeaderId"
      >
        <j-input-popup
          :style="isModal ? 'width: 100%' : 'width: 300px'"
          v-model="departBranchLeader"
          placeholder="请选择部门分管领导"
          component="SelectUserTreeModal"
          :params="{
            multiFlg: '0',
            departFlg: '1',
            selectUserList: departBranchLeader,
          }"
          @change="changeDepartBranchLeader"
        ></j-input-popup>
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        prop="departLeaderId"
      >
        <span slot="label">
          <span style="font-size: 13px" class="inlineNote">（正职）</span>
          <span>部门负责人</span>
        </span>

        <j-input-popup
          :style="isModal ? 'width: 100%' : 'width: 300px'"
          v-model="departLeader"
          placeholder="请选择部门负责人（正职）"
          component="SelectUserTreeModal"
          :params="{
            multiFlg: '0',
            departFlg: '1',
            selectUserList: departLeader,
          }"
          @change="changeDepartLeader"
        ></j-input-popup>
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        prop="departDeputyLeaderId"
      >
        <span slot="label">
          <span style="font-size: 13px" class="inlineNote">（副职）</span>
          <span>部门负责人</span>
        </span>

        <j-input-popup
          :style="isModal ? 'width: 100%' : 'width: 300px'"
          v-model="departDeputyLeader"
          placeholder="请选择部门负责人（副职）"
          component="SelectUserTreeModal"
          :params="{
            multiFlg: '1',
            departFlg: '1',
            selectUserList: departDeputyLeader,
          }"
          @change="changeDepartDeputyLeader"
        ></j-input-popup>
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        label="管辖省份"
        prop="childProvince"
      >
        <a-select
          mode="multiple"
          v-model="form.childProvinceArray"
          :placeholder="$t('disp.ph.select', ['管辖省份'])"
          @change="changeChildProvince"
        >
          <template v-for="(item, index) in provinceCityOptions">
            <a-select-option :key="index" :value="item.value" v-if="item.value !== '00'">{{
              item.label
            }}</a-select-option>
          </template>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        :label="$t('disp.address1')"
        prop="address1"
      >
        <a-input :placeholder="$t('disp.ph.input', [$t('disp.address1')])" v-model="form.address1" :maxLength="255" />
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        :label="$t('disp.mobile')"
        prop="mobile"
      >
        <a-input :placeholder="$t('disp.ph.input', [$t('disp.mobile')])" v-model="form.mobile" :maxLength="32" />
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        :label="$t('disp.fax')"
        prop="fax"
      >
        <a-input :placeholder="$t('disp.ph.input', [$t('disp.fax')])" v-model="form.fax" :maxLength="32" />
      </a-form-model-item>

      <!--<a-form-model-item :labelCol="!isModal ? labelCol : labelColModal" :wrapperCol="!isModal ? wrapperCol : wrapperColModal" :label="$t('disp.zipCode')" prop="zipCode">
        <a-input :placeholder="$t('disp.ph.input', [$t('disp.zipCode')])" v-model="form.zipCode" :maxLength="32" />
      </a-form-model-item>

      <a-form-model-item :labelCol="!isModal ? labelCol : labelColModal" :wrapperCol="!isModal ? wrapperCol : wrapperColModal" :label="$t('disp.email')" prop="emailAddress">
        <a-input :placeholder="$t('disp.ph.input', [$t('disp.email')])" v-model="form.emailAddress" :maxLength="256" />
      </a-form-model-item>-->

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        :label="$t('disp.note')"
        prop="memo"
      >
        <a-textarea
          @keyup.enter.stop
          :placeholder="$t('disp.ph.input', [$t('disp.note')])"
          v-model="form.memo"
          :maxLength="255"
          :autoSize="{
            minRows: 1,
          }"
        />
      </a-form-model-item>

      <a-form-model-item
        :labelCol="!isModal ? labelCol : labelColModal"
        :wrapperCol="!isModal ? wrapperCol : wrapperColModal"
        v-if="!isModal && !executeDisabled && !changePlanId"
        label="确定"
        class="no-label"
      >
        <a-button @click="handleSubmit" type="primary" icon="check" style="float: right">{{
          $t('disp.btn.confirm')
        }}</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import pcJson from '@/common/map/json/pc-code.json'

class formDef {
  changePlanId = undefined
  departName = undefined
  parentId = undefined
  orgCategory = undefined
  isFundStat = true
  sortOrder = 0
  departLeaderId = undefined
  departBranchLeaderId = undefined
  mobile = undefined
  fax = undefined
  zipCode = undefined
  address1 = undefined
  memo = undefined
  childProvince = undefined
  childProvinceArray = undefined
  departDeputyLeaderId = undefined
  nccCode = undefined
}

export default {
  name: 'DepartInfo',
  components: {},
  props: {
    // 是否弹出框
    isModal: {
      type: Boolean,
      default: false,
    },
    // 组织变更计划ID
    changePlanId: {
      type: String,
      default: '',
    },
    // 是否可以编辑
    executeDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      form: new formDef(),
      departTree: [],
      departLeader: [],
      departBranchLeader: [],
      departDeputyLeader: [],
      // 省市json
      provinceCityOptions: pcJson,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      labelColModal: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperColModal: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      rules: {
        departName: [this._r.required],
        sortOrder: [this._r.required],
        departLeaderId: [],
        departBranchLeaderId: [],
        //zipCode: {
        //  rules: [
        //    {
        //      pattern: /^[0-9-]{0,}$/,
        //      message: this.$t('disp.rules.regex'),
        //    },
        //  ],
        //},
        //mobile: {
        //  rules: [
        //    {
        //      pattern: /^[0-9,~!@#$%^&*()_+`\-={}:";'<>?,./\[\]\|\\]{0,}$/,
        //      message: this.$t('disp.rules.halfNumSymbol'),
        //    },
        //  ],
        //},
        //fax: {
        //  rules: [
        //    {
        //      pattern: /^[0-9,~!@#$%^&*()_+`\-={}:";'<>?,./\[\]\|\\]{0,}$/,
        //      message: this.$t('disp.rules.halfNumSymbol'),
        //    },
        //  ],
        //},
        //emailAddress: {
        //  rules: [
        //    {
        //      pattern:
        //        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        //      message: this.$t('disp.rules.regex'),
        //    },
        //  ],
        //},
      },
      url: {
        add: '/blaze-sys/k00/k0002/DepartManage/add',
        edit: '/blaze-sys/k00/k0002/DepartManage/edit',
        queryIdTree: '/blaze-sys/k00/k0015/DepartAction/queryIdTree',
      },
    }
  },
  created() {},
  methods: {
    loadTreeData() {
      if (this.changePlanId) {
        getAction(this.url.queryIdTree, { changePlanId: this.changePlanId }).then((res) => {
          if (res.success) {
            this.departTree = []
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              this.departTree.push(temp)
            }
          }
        })
      } else {
        this.departTree = this.$getDepartTree()
      }
    },
    add(departId, currCategory) {
      // 使用form定义初始化form
      this.form = new formDef()

      this.form.parentId = departId != null ? departId.toString() : null
      this.form.orgCategory = currCategory != null ? currCategory.toString() : null

      this.loadTreeData()
    },
    async edit(departInfo) {
      this.rules['departLeaderId'] = [this._r.required]
      this.rules['departBranchLeaderId'] = [this._r.required]

      // 管辖省份多选框
      if (departInfo.childProvince) {
        departInfo.childProvinceArray = departInfo.childProvince.split(',')
      }

      // 使用form定义初始化form
      this.form = new formDef()
      this.form = Object.assign({}, departInfo)

      this.departLeader = []
      if (this.form.departLeaderId) {
        var sysUser = await this.$getSysUser(this.form.departLeaderId)

        this.departLeader.push({
          value: sysUser.id,
          text: sysUser.realname,
        })
      }

      this.departBranchLeader = []
      if (this.form.departBranchLeaderId) {
        var sysUser = await this.$getSysUser(this.form.departBranchLeaderId)

        this.departBranchLeader.push({
          value: sysUser.id,
          text: sysUser.realname,
        })
      }

      // 部门负责人（副职）
      this.departDeputyLeader = []
      if (this.form.departDeputyLeaderId) {
        var leaderIds = this.form.departDeputyLeaderId.split(',')
        if (leaderIds && leaderIds.length > 0) {
          leaderIds.forEach(async (leader) => {
            var sysUser = await this.$getSysUser(leader)
            this.departDeputyLeader.push({
              value: sysUser.id,
              text: sysUser.realname,
            })
          })
          this.form.departDeputyLeaderId = XEUtils.toJSONString(leaderIds)
        }
      }

      this.loadTreeData()
    },
    handleSubmit() {
      if (this.executeDisabled) {
        return
      }

      this.$refs.form.validateFieldsAndScroll((ok) => {
        if (ok) {
          if (this.loading) {
            return
          } else {
            this.loading = true
          }

          let url = this.isModal ? this.url.add : this.url.edit
          if (this.changePlanId) {
            this.form.changePlanId = this.changePlanId
            url = url.replaceAll('/blaze-sys/k00/k0002/DepartManage/', '/blaze-sys/k00/k0015/DepartAction/')
          }

          httpAction(url, this.form, 'post')
            .then((res) => {
              if (res.success) {
                this.$message.success(this.$t(res.message))
                this.$getDepartTree(null, true)
                this.$emit('emit')
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    changeDepartLeader(selected) {
      if (selected.length > 0) {
        this.form.departLeaderId = selected[0].value
      } else {
        this.form.departLeaderId = undefined
      }
    },
    changeDepartDeputyLeader(selected) {
      if (selected.length > 0) {
        this.form.departDeputyLeaderId = XEUtils.toJSONString(XEUtils.map(selected, (item) => item.value))
      } else {
        this.form.departDeputyLeaderId = undefined
      }
    },
    changeDepartBranchLeader(selected) {
      if (selected.length > 0) {
        this.form.departBranchLeaderId = selected[0].value
      } else {
        this.form.departBranchLeaderId = undefined
      }
    },
    changeChildProvince(selected) {
      this.form.childProvince = selected.join(',')
    },
  },
}
</script>

<style lang="less" scoped>
.anticon-arrow-right {
  font-size: 15px;
  animation: fadeIn ease-in-out 1.2s infinite;
  position: relative;
  top: 0px;
}

@keyframes fadeIn {
  0% {
    transform: translateX(0px);
    opacity: 1;
  }

  50% {
    transform: translateX(3px);
    opacity: 0.8;
  }

  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}
</style>
